import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Text } from '@naf/text';
import { spacing, borderRadius } from '@naf/theme';
import { themeLight } from '@lib/nafTheme';
import { nafColor } from '@nafcore/theme';
import { colors } from '@naf-simba/theme';
import { isNotTransientProp } from '../../lib/shouldForwardProp';

export const Container = styled.div`
  max-width: 400px;
  display: flex;
  align-items: center;
`;

export const IconContainer = styled.div<{ $isEligible?: boolean }>`
  border-radius: ${borderRadius.S};
  width: ${spacing.space20};
  height: ${spacing.space20};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${nafColor.signature.black};
  background-color: ${({ $isEligible }) => ($isEligible ? colors.secondary[300] : nafColor.signature.yellow)};
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${spacing.space4};
  padding: 3px ${spacing.space4};
  border: 1px solid ${themeLight.border.default};
  border-radius: ${borderRadius.M};
`;

export const StyledText = styled(Text, { shouldForwardProp: isNotTransientProp })<{ $inverted?: boolean }>`
  ${({ $inverted }) =>
    $inverted &&
    css`
      color: ${nafColor.signature.white};
    `}
`;
